var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { Icon, Inset, Stack, Text } from '@doordash/design-language';
import { CreateBudgetPlaceOrderStrings } from './PlaceOrderStrings';
import { useDispatch } from 'react-redux';
import { addTeamAccountGroupHook, fetchTeamAccountGroups, } from '../Groups/groups_slice';
import { useAddTeamMembersToGroupByEmailMutation } from '../GroupsMembers/useAddTeamMembersToGroupByEmailMutation';
import { addTeamAccountBudget } from '../MealBudgets/budgets_slice';
import { BUDGET_EXPIRE_IN_DAYS, getAutoCreatedGroupDescription, getAutoCreatedGroupName, getOneTimeBudgetOptions, } from './utils';
import { useToast } from '@doordash/component-toast';
import { BudgetForm } from './BudgetForm';
import track from '../../utils/track';
import { PlaceOrderEvents } from '../../constants/events/names';
var strings = CreateBudgetPlaceOrderStrings;
var DEFAULT_PAGE_SIZE = 100;
// This component is built to accommodate a requested feature from Kaiser admins
// We will make this available to them for X days, to track its use and
// conversion with a less hassle ordering workflow.
// This contains a lot of hacky ways of development.
// If measured to be a success, this will require a cleanup (DDC-4975)
export var CreateBudgetPlaceOrder = function (_a) {
    var teamAccountId = _a.teamAccountId, teamMemberEmail = _a.teamMemberEmail, onCreateBudgetSuccess = _a.onCreateBudgetSuccess;
    var dispatch = useDispatch();
    var displayToast = useToast().displayToast;
    var addTeamMembersToGroupByEmail = useAddTeamMembersToGroupByEmailMutation().addTeamMembersToGroupByEmail;
    var _b = __read(React.useState({
        groupListPage: 1,
        groupListPageSize: DEFAULT_PAGE_SIZE,
    }), 2), groupPaginationProps = _b[0], setGroupPaginationProps = _b[1];
    var _c = __read(React.useState(''), 2), groupIdForPlaceOrder = _c[0], setGroupIdForPlaceOrder = _c[1];
    var _d = __read(React.useState(''), 2), errorMessage = _d[0], setErrorMessage = _d[1];
    React.useEffect(function () {
        track(PlaceOrderEvents.PAGE_VIEW, {
            team_account_id: teamAccountId,
            version: 1,
        });
    }, [teamAccountId]);
    React.useEffect(function () {
        setGroupIdForPlaceOrder('');
        // retrieve team account group for individual placing an order
        dispatch(fetchTeamAccountGroups({
            teamAccountId: teamAccountId,
            pageSize: groupPaginationProps.groupListPageSize,
            pageNumber: groupPaginationProps.groupListPage,
        }))
            .unwrap()
            .then(function (data) {
            var _a, _b, _c;
            // This is a very hacky way of looking for a group that was previously created for the place order feature
            // since we do not want to keep repeating group creation for 1 person
            // if this feature is rolled out to more enterprise customers we will need to build this with a dedicated BE
            var groupForPlaceOrder = (_a = data === null || data === void 0 ? void 0 : data.teamAccountGroups) === null || _a === void 0 ? void 0 : _a.find(function (group) { return group.name === getAutoCreatedGroupName(teamMemberEmail); });
            if (groupForPlaceOrder) {
                setGroupIdForPlaceOrder(groupForPlaceOrder.id);
            }
            else {
                var groupListPage = groupPaginationProps.groupListPage, groupListPageSize = groupPaginationProps.groupListPageSize;
                // check if there are more groups to load
                var totalCount = (_c = (_b = data === null || data === void 0 ? void 0 : data.pagination) === null || _b === void 0 ? void 0 : _b.totalCount) !== null && _c !== void 0 ? _c : 0;
                var totalPages = Math.ceil(totalCount / groupListPageSize);
                var hasNextPage = groupListPage < totalPages;
                if (hasNextPage) {
                    setGroupPaginationProps(__assign(__assign({}, groupPaginationProps), { groupListPage: groupListPage + 1 }));
                }
            }
        });
    }, [teamAccountId, teamMemberEmail, groupPaginationProps, dispatch]);
    var createGroupForOne = function () { return __awaiter(void 0, void 0, void 0, function () {
        var groupOptions, response, createdGroupId, emails, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    groupOptions = {
                        teamAccountId: teamAccountId,
                        name: getAutoCreatedGroupName(teamMemberEmail),
                        description: getAutoCreatedGroupDescription(teamMemberEmail),
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, dispatch(addTeamAccountGroupHook(groupOptions)).unwrap()];
                case 2:
                    response = _b.sent();
                    createdGroupId = response.teamAccountGroup.id;
                    emails = [teamMemberEmail];
                    return [4 /*yield*/, addTeamMembersToGroupByEmail(createdGroupId, emails)];
                case 3:
                    _b.sent();
                    setGroupIdForPlaceOrder(createdGroupId);
                    return [2 /*return*/, createdGroupId];
                case 4:
                    _a = _b.sent();
                    return [2 /*return*/, ''];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var createBudgetForImmediatePlaceOrder = function (name, teamAccountId, unitAmount, groupId) { return __awaiter(void 0, void 0, void 0, function () {
        var budgetOptions, response, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    budgetOptions = getOneTimeBudgetOptions({
                        name: name,
                        teamAccountId: teamAccountId,
                        unitAmount: unitAmount,
                        groupId: groupId,
                    });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, dispatch(addTeamAccountBudget(budgetOptions)).unwrap()];
                case 2:
                    response = _b.sent();
                    return [2 /*return*/, response.id];
                case 3:
                    _a = _b.sent();
                    return [2 /*return*/, ''];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var createBudgetAndStartOrder = function (formValues) { return __awaiter(void 0, void 0, void 0, function () {
        var groupId, budgetId, budgetAmountInCents;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    track(PlaceOrderEvents.START_ORDER_CLICK, {
                        team_account_id: teamAccountId,
                        budget_amount: formValues.budgetAmount,
                    });
                    setErrorMessage('');
                    groupId = groupIdForPlaceOrder;
                    budgetId = '';
                    if (!!groupIdForPlaceOrder) return [3 /*break*/, 2];
                    return [4 /*yield*/, createGroupForOne()];
                case 1:
                    groupId = _a.sent();
                    _a.label = 2;
                case 2:
                    if (!groupId) return [3 /*break*/, 4];
                    budgetAmountInCents = Math.floor(formValues.budgetAmount * 100) // only consider 2 decimal places
                    ;
                    return [4 /*yield*/, createBudgetForImmediatePlaceOrder(formValues.budgetName, teamAccountId, budgetAmountInCents, groupId)];
                case 3:
                    budgetId = _a.sent();
                    _a.label = 4;
                case 4:
                    if (budgetId) {
                        // display success message to admin
                        displayToast({
                            icon: Icon.Types.Check,
                            text: strings.toastMsg.success(formValues.budgetName),
                            insetFromEdge: Inset.Sizes.XxxLarge,
                        });
                        track(PlaceOrderEvents.CREATE_BUDGET_SUCCESS, {
                            team_account_id: teamAccountId,
                            budget_id: budgetId,
                            budget_amount: formValues.budgetAmount,
                        });
                        onCreateBudgetSuccess();
                        return [2 /*return*/];
                    }
                    // failed
                    track(PlaceOrderEvents.CREATE_BUDGET_FAIL, {
                        team_account_id: teamAccountId,
                        budget_id: budgetId,
                        budget_amount: formValues.budgetAmount,
                    });
                    setErrorMessage(strings.errors.budgetNotCreatedPleaseTryAgain());
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(React.Fragment, null,
        React.createElement(Stack, null,
            React.createElement(Text, { styles: Text.Styles.Body1, children: strings.description1() }),
            React.createElement(Text, { children: strings.expireDescription(BUDGET_EXPIRE_IN_DAYS), styles: Text.Styles.Body1Emphasis })),
        React.createElement(Stack, { size: Stack.Sizes.XLarge }),
        React.createElement(BudgetForm, { errorMessage: errorMessage, handleFormSubmit: createBudgetAndStartOrder })));
};
